var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgLogoSquare(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Tips - RTV Tipsters"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 25,
    height: 25,
    rx: 5,
    ry: 5,
    fill: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M22.11 19.57h-3.14l-4.27-6.12h-4.43L8.48 10.9h9.03c.9 0 1.63-.81 1.63-1.83 0-.99-.73-1.8-1.63-1.8H5.92L4.11 4.69H17c1.46 0 2.65.45 3.52 1.37.79.83 1.18 1.82 1.18 3 0 .98-.35 1.87-1.05 2.64-.68.78-1.63 1.27-2.82 1.53l4.27 6.33z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
export default SvgLogoSquare;